<div class="text-center connection-status p-2 bg-danger"
     title="{{warning}}" *ngIf="show">
  <i class="fa fa-exclamation-triangle"></i>&nbsp;
  Connecting...
</div>
